import React, { useContext, useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Context } from "../LocalWrapper";
import Cookies from "js-cookie";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";

import "./PublicNotificationStyle.css";

function PublicNotification() {
  const context = useContext(Context);
  const closePubNotification = Cookies.get("closePubNotification");

  const [publicNotifications, setPublicNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notificationClose, setNotificationClose] = useState(false);

  useEffect(() => {
    if (closePubNotification) {
      setNotificationClose(closePubNotification);
    }
  }, [closePubNotification]);

  const handleNotificationBar = () => {
    setNotificationClose(true);
    Cookies.set("closePubNotification", true, { expires: 1 });
  };

  useEffect(() => {
    // Fetch notifications
    fetch("/assets/public_data/PublicNotification.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const messages =
          context.currentLang.code === "AR"
            ? data?.ar_message
            : data?.en_message;
        setPublicNotifications(messages || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, [context.currentLang.code]);

  if (loading || notificationClose || publicNotifications.length === 0)
    return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        p: "10px 5px",
        bgcolor: "var(--dark-transparent)",
        boxShadow: { xs: "none", sm: "0px 2px 3px #0000009d" },
      }}
      dir={context.dir}
    >
      {/* Scrolling Notification */}
      <Box className="scrolling-notification">
        <div
          className={`scrolling-text ${context.dir === "rtl" ? "rtl" : "ltr"}`}
        >
          {/* Loop the messages to create continuous scrolling */}
          {publicNotifications
            .map((item) => item.text)
            .concat(publicNotifications.map((item) => item.text))
            .join("\u00A0\u00A0\u00A0\u00A0\u00A0")}
        </div>
      </Box>

      {/* Close Button */}
      <Box
        sx={{
          flex: 1,
          color: "white",
          ":hover": { color: "red" },
          ml: "10px",
        }}
      >
        <IconButton
          color="inherit"
          aria-label="close notification"
          edge="start"
          onClick={handleNotificationBar}
        >
          <CancelPresentationIcon
            fontSize="small"
            sx={{ width: "30px", height: "30px" }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}

export default PublicNotification;
